module.exports = __webpack_public_path__ + "static/media/Responsibility Bias.8159eb07.jpg";